  <template>
  <tea-main @back="goBack">
    <template slot="nav">
      <div class="teaNav">
        <p style="cursor: pointer" @click="$router.push('tea')">讲师管理</p>
        <p  class="zuxie-btn" style="margin-left: 20px;cursor: pointer">助理讲师晋升</p>
        <p style="margin-left: 20px;cursor: pointer" @click="$router.push('tea_removes')">取消资格讲师</p>
      </div>
    </template>
    <template slot="main">
      <div class="teaMain">
        <div class="searchWrap">
          <div class="selectWrap">
            <select v-model="search.work_unit_id"
                    @change="updateWorkUnit()">
              <option value="">全部注册协会</option>
              <option v-for="(item, index) in AssociationList"
                      :key="index"
                      :value="item.org_id">{{ item.org_abbreviation }}
              </option>
            </select>
            <select v-model="search.num"
              @change="updateWorkUnit()">
              <option value=""> 全部次数</option>
              <option value="5"> 5次</option>
              <option value="4"> 4次</option>
              <option value="3"> 3次</option>
              <option value="2"> 2次</option>
              <option value="1"> 1次</option>
            </select>
            <select v-model="search.teacher_level" @change="updateWorkUnit()">
              <option value="">全部等级讲师级别</option>
              <option
                v-for="(item, index) in filterData.teacher_level"
                :key="index"
                :value="item.value"
              >
                {{ item.key }}
              </option>
            </select>
<!--            <select v-model="search.city_id" @change="getRequest">-->
<!--              <option value="">全部城市</option>-->
<!--              <option v-for="(item, index) in filterData.city"-->
<!--                      :key="index"-->
<!--                      :value="item.id">{{ item.regionName }}-->
<!--              </option>-->
<!--            </select>-->
          </div>
          <div class="search">
            <div class="wrap">
              <input v-model.lazy="search.name"
                     type="text"
                     placeholder="请输入搜索内容"
                     @keyup.enter="getRequest">
              <div v-show="search.name!=''"
                   class="close"
                   @click="hideIcon">
                <v-icon name="regular/times-circle"
                        scale="1.2"></v-icon>
              </div>
            </div>
            <div class="searchBtn"
                 @click="getRequest">搜索
            </div>
          </div>
        </div>
        <yioks-loading v-show="isLoading"></yioks-loading>
        <template v-if="!isLoading">
          <template v-if="showList">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th index"><strong>序号</strong></div>
                  <div class="th name"><strong>讲师姓名</strong></div>
                  <div class="th status"><strong>讲师等级</strong></div>
                  <div class="th leisure"><strong>助理课程次数</strong></div>
                  <div class="th org"><strong>注册协会</strong></div>
                  <div class="th phone"><strong>分数</strong></div>
                  <div class="th opt"><strong>操作</strong></div>
                </div>
              </div>
              <div class="scrollArea" v-if="showList">
                <vue-scroll :ops="ops" ref="vs">
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div class="tr"
                           v-for="(item, index) in list"
                           :key="index">
                        <div class="td index">
                          <p>{{ index+1 }}</p>
                        </div>
                        <div class="td name">
                          <p :title="item.name">{{ item.name }}</p>
                        </div>
                        <div class="td status">
                          <p>{{item.teacher_level | teacherFilter(false)}}</p>
                        </div>
                        <div class="td leisure">
                          <p>{{item.train_promote_number}}</p>
                        </div>
                        <div class="td org">
                          <p>{{ item.work_unit||"--" }}</p>
                        </div>
                        <div class="td phone" style="display:flex; justify-content:center">
                          <div class="td score-item">{{ item.score[0] }}</div>
                          <div class="td score-item">{{ item.score[1] }}</div>
                          <div class="td score-item">{{ item.score[2] }}</div>
                          <div class="td score-item">{{ item.score[3] }}</div>
                          <div class="td score-item" style="color: #fff">{{ item.score[4] }}</div>
                        </div>
                        <div class="td opt">
                          <span @click="lookOver(item.teacher_id)">查看</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
            <div id="paging">
              <yioks-paging :paging="paging"
                            @goto-page="gotoPage($event)"></yioks-paging>
            </div>
          </template>
          <yioks-empty v-show="showEmpty"></yioks-empty>
        </template>
        <template v-if="showSingle">
          <tea-dialog :visible="showSingle"
                      @flag="changeFlag"></tea-dialog>
        </template>

        <teas-dialog :visible="showMany"
                     @hideUpload="hideUpload"></teas-dialog>
      </div>
    </template>
  </tea-main>
</template>

<script>
  import {smTeacherPromote,orgList} from "@/api/system_manager/api";
  import {area_list} from "@/assets/js/region";
  import {teacher_level} from "@/assets/js/select";
  import ops from '@/assets/js/vuescrollOption';
  import {teacherAssociation} from "@/api/training_teacher/api";
  import { teacherFilter } from '@/assets/js/yioksFilters';
  // import {addTeacher,orgList} from "@/api/system_manager/api";
  export default {
    name: "Teacher",
    data() {
      return {
        ops: ops(),
        isLoading: true,
        showMany: false,
        showSingle: false,
        showList: false,
        showEmpty: false,
        list: [],
        page: 1,
        paging: {
          start: 0,
          prePage: 1, // 一页多少条数据
          total: 0, // 总页数
          size: 3, // 页码显示限制
          last: true, // 尾页
          next: true, // 下一页
          first: true, // 首页
          previous: true, // 上一页
          jump: true
        },
        search: {
          // province_id: "",
          // city_id: "",
          name: "",
          work_unit_id: '',
          teacher_level: '',
          num: '',
        },
        filterData: {
          teacher_level: teacher_level,
          area: area_list,
          city: [],
        },
        AssociationList:[],
        visible2: false,
      }
    },
    components: {
      "tea-main": () => import("@/components/LayOut/Common/up-down"),
      "yioks-paging": () => import("@/components/Pagination/Page"),
      "tea-dialog": () => import("@/views/system_manager/teacher/tea-add"),
      "teas-dialog": () => import("@/views/system_manager/teacher/teas-add"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "v-icon": () => import("vue-awesome/components/Icon"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
    },
    created() {
      this.setData();
      this.getOrgList()
      this.request();
    },
    filters: {
      teacherFilter,
      userStatus(status) {
        switch (status) {
          case "Active":
            status = "正常";
            break;
          case "Abnormal":
            status = "暂停";
            break;
          case "Stop":
            status = "关闭";
            break;
          case "Deleted":
            status = "关闭";
            break;
          default:
            status = "--";
            break;
        }
        return status;
      },
      scoreFilter(val) {
        return val.join('|')
      }
    },
    methods: {
      getOrgList() {
        orgList({})
          .then((res) => {
            this.AssociationList = res.data.result.organization;
          })
          .catch((err) => {
            console.log(err);
          });
      },
      setData(){
        // console.log(this.$route.query);
        const {page, work_unit_id,num,  name,teacher_level} = this.$route.query;
        page && (this.page = page);
        work_unit_id && (this.$set(this.search,'work_unit_id',work_unit_id))
        num && (this.$set(this.search,'num',num))
        teacher_level && (this.$set(this.search,'teacher_level',teacher_level))
        // pid && (this.$set(this.search, "province_id", pid));
        // pid && (this.getCityList());
        // cid && (this.$set(this.search, "city_id", cid));
        name && (this.$set(this.search, "name", name));
      },
      goBack() {
        this.$router.push('/system/sm');
      },
      request() {
        this.isLoading = true;
        smTeacherPromote({"page": this.page, ...this.search})
          .then(res => {
            this.isLoading = false;
            // console.log(res);
            const {result} = res.data;
            this.$set(this.paging, "prePage", result.page.page_size);
            this.$set(this.paging, "total", result.page.total_row);
            this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
            this.list = result.list;
            this.showList = result.list.length > 0;
            this.showEmpty = !this.showList;
          })
          .catch(err => {
            this.isLoading = false;
            console.error(err);
          });
      },
      changeFlag(bool, flag) {
        this.showSingle = bool;
        if (flag) {
          this.request();
        }
      },
      hideUpload(bool, flag) {
        if (flag) {
          // 更新列表
          this.request();
        }
        this.showMany = bool;
      },
      addMany() {
        // console.log("批量添加~");
        this.showMany = true;
      },
      addTeacher() {
        // console.log("添加讲师~");
        this.showSingle = true;
      },
      hideIcon() {
        this.$set(this.search, "name", "");
        this.getRequest();
      },
      getLeisure() {
        this.$refs["search"].validate((valid) => {
          if (valid) {
            this.visible2 = false;
            this.$set(this.search, "isSelectTime", 1);
            this.changeQuery(true);
          } else {
            console.error('error submit!!');
            return false;
          }
        });
      },
      clearLeisure() {
        // 清除开始时间  结束时间 和空闲状态
        this.visible2 = false;
        this.changeQuery(true);
      },
      getRequest() {
        this.visible2 = false;
        this.changeQuery(true);
      },
      gotoPage: function (start) {
        this.page = parseInt(start / this.paging.prePage) + 1;
        this.changeQuery(false);
        this.$refs['vs'].scrollTo({ y: 0 });
      },
      updateCity() {
        this.$set(this.search, "city_id", "");
        // this.getCityList();
        this.getRequest();
      },
      updateWorkUnit(){
        this.changeQuery(true)
      },
      getCityList() {
        // console.log(this.search.province_id);
        const city = this.$yioks.updateCity(this.search.province_id, this.filterData.area);
        this.$set(this.filterData, "city", city);
      },

      changeQuery(flag) {
        flag && (this.page = 1);
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            page: this.page,
            // pid: this.search.province_id,
            // cid: this.search.city_id,
            work_unit_id:this.search.work_unit_id,
            teacher_level:this.search.teacher_level,
            num:this.search.num,
            name: this.search.name
          }
        });
        this.request();
      },
      lookOver(id) {
        this.$router.push({path: 'td', query: {id: id}});
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  @import "~@/assets/css/mixin";
  .teaNav, .teaMain {
    flex: 1 1 auto;
    height: 100%;
  }

  .teaNav {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px 0 0;
    font-size: $font_size_big;
    .btnWrap {
      display: flex;
      align-items: center;
      .btn {
        width: 100px;
        height: 36px;
        margin: 0 0 0 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $color_suc;
        cursor: pointer;
      }
    }
  }

  .teaMain {
    width: 100%;
    padding: 25px 0 0;
    background-color: $block_bg_color_base;
    .searchWrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      margin: 0 40px;
      .selectWrap {
        height: 100%;
        select {
          width: 130px;
          height: 100%;
          margin: 0 10px 0 0;
          padding: 0 0 0 10px;
          font-size: 16px;
          color: $color_black;
          outline: none;
        }
      }
      .search {
        width: 385px;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .wrap {
          height: 100%;
          position: relative;
          input {
            width: 220px;
            height: 100%;
            padding: 0 20px;
            font-size: $font_size_medium;
            color: $color_black;
            outline: none;
          }
          .close {
            position: absolute;
            right: 5px;
            top: 10px;
            color: $color_info;
            cursor: pointer;
          }
        }
        .searchBtn {
          width: 90px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          background-color: $color_suc;
          cursor: pointer;
        }
        .leisureBtn{
          font-size: 15px;
          color: $color_suc;
          margin-right 15px
        }
      }
    }
    .table {
      width: 100%;
      margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 401px;
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        margin-left auto
        margin-right auto
        width: 810px;
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        flex: 1 1 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td:last-child {
        color: $color_suc;
        user-select: none;
      }
      .td {
        p {
          over_hide();
        }
      }
      .index {
        width: 6%;
      }
      .name {
        width: 12%;
      }
      .level {
        width: 15%;
      }
      .org {
        width: 13%;
      }
      .phone {
        width: 30%;
        .score-item {
          width 18%;
          text-align center
        }
      }
      .leisure {
        width: 10%;
      }
      .status {
        width: 8%;
      }
      .opt {
        width: 6%;
        span {
          cursor: pointer;
        }
      }
    }
    #paging {
      width: 100%;
      height: 77px;
    }
  }

  .btns {
    display: flex;
    justify-content: center;
    color: $color_white;
    .btn {
      padding: 10px 0px;
      margin: 0 10px;
      border-radius: 4px;
      cursor: pointer;
      user-select: none;
    }
    .save {
      background-color: $color_suc;
      width :50%;
      text-align: center;
    }
    .cancel {
      background-color: $color_primary;
      width :50%;
      text-align: center;
    }
  }
</style>
